import SpinWheelCue from '../../assets/sounds/phase1/SpinWheel.mp3';

const SPIN_FADE_MS = 320;
let spinEl = null;
let spinFadeTimer = 0;
let muted = false;

function getSpinEl() {
  if (typeof window === 'undefined') return null;
  if (spinEl) return spinEl;
  spinEl = new Audio(SpinWheelCue);
  spinEl.preload = 'auto';
  spinEl.loop = true;
  spinEl.volume = 1;
  return spinEl;
}

export function setPhase1Muted(value) {
  muted = Boolean(value);
  if (muted) {
    stopPhase1SpinAudio({ immediate: true });
  }
}

/** Loop the wheel sound for as long as the wheel is turning. */
export function startPhase1SpinAudio() {
  if (typeof window === 'undefined' || muted) return;
  const el = getSpinEl();
  if (!el) return;
  window.clearTimeout(spinFadeTimer);
  try {
    el.loop = true;
    el.volume = 1;
    el.currentTime = 0;
    el.play().catch(() => {});
  } catch (_error) {
    // Autoplay restrictions
  }
}

/** Short fade so the sound settles with the wheel instead of cutting off. */
export function stopPhase1SpinAudio({ immediate = false } = {}) {
  if (typeof window === 'undefined') return;
  const el = spinEl;
  if (!el || el.paused) return;
  window.clearTimeout(spinFadeTimer);
  if (immediate) {
    try {
      el.pause();
      el.currentTime = 0;
    } catch (_error) {}
    el.volume = 1;
    return;
  }
  const startVol = el.volume;
  const started = performance.now();
  const step = () => {
    const t = Math.min(1, (performance.now() - started) / SPIN_FADE_MS);
    el.volume = Math.max(0, startVol * (1 - t));
    if (t < 1) {
      spinFadeTimer = window.setTimeout(step, 32);
      return;
    }
    try {
      el.pause();
      el.currentTime = 0;
    } catch (_error) {}
    el.volume = 1;
  };
  step();
}
